import { InventoryAdmin } from 'src/app/proto/generated/inv_api_message_pb';

export class InventoryAdminModel {
  taskName: string;
  skipCodeSource: string;
  skipCode: string;
  inventoryStatusSource: string;
  inventoryStatus: string;
  comment: string;
  comment_title: string;
  taskToCreate: string;

  static Mapper(source: InventoryAdmin): InventoryAdminModel {
    const destination: InventoryAdminModel = new InventoryAdminModel();
    destination.taskName = source.getTaskName();
    destination.skipCode = source.getSkipCode();
    destination.inventoryStatus = source.getInventoryStatus();
    destination.comment = source.getComment();
    destination.taskToCreate = source.getTaskToCreate();
    return destination;
  }

  static MapperList(source: InventoryAdmin[]): InventoryAdminModel[] {
    const list: InventoryAdminModel[] = [];
    source?.forEach((element) => {
      list.push(InventoryAdminModel.Mapper(element));
    });
    return list;
  }

  static MapperProto(source: InventoryAdminModel): InventoryAdmin {
    const destination: InventoryAdmin = new InventoryAdmin();
    destination.setTaskName(source.taskName);
    destination.setSkipCode(source.skipCode);
    destination.setInventoryStatus(source.inventoryStatus);
    destination.setComment(source.comment);
    destination.setTaskToCreate(source.taskToCreate);
    return destination;
  }
}
